import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Lets global UI (e.g. nav "New Recording") coordinate with {@link RecordingComponent} when capture is active.
 */
@Injectable({ providedIn: 'root' })
export class RecordingSessionService {
  /** True while the recording page has an active or paused capture (mic session). */
  private readonly captureActive = signal(false);

  readonly captureActiveReadonly = this.captureActive.asReadonly();

  setCaptureActive(value: boolean): void {
    this.captureActive.set(value);
  }

  isCaptureActive(): boolean {
    return this.captureActive();
  }

  private readonly newRecordingFromNav = new Subject<void>();
  readonly newRecordingFromNav$ = this.newRecordingFromNav.asObservable();

  /** User chose New Recording in the header while a visit is in progress on /recording. */
  requestNewRecordingFromNav(): void {
    this.newRecordingFromNav.next();
  }
}
